import { ReactNode } from 'react';

import { MainAppHeader } from '@/components/MainAppHeader/MainAppHeader';

export type PrivateLayoutProps = {
  children?: ReactNode;
};

export function PrivateLayout({ children }: PrivateLayoutProps) {
  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden bg-gray-950 pb-16">
      <MainAppHeader />
      <div className="flex-1 min-h-0 w-full">{children}</div>
    </div>
  );
}

export default PrivateLayout;
